var map = {
	"./Coinsdataflow.jpeg": 171,
	"./Cointelegraph.jpeg": 172,
	"./Concerto-Logo.png": 173,
	"./EY.jpeg": 174,
	"./FinancialIT.jpeg": 175,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---blue-type.png": 176,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---white-type.png": 177,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-blue-version.png": 178,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-white-version.png": 179,
	"./IDS Fintech Logo/fintech logo/high Res horizontal/landscape-white-text.png": 180,
	"./ManageEngine.png": 181,
	"./NIIT.jpeg": 182,
	"./Neosoft.jpeg": 183,
	"./NewsAffinity.jpeg": 184,
	"./Payoneer.jpeg": 185,
	"./TEMENOS.png": 186,
	"./Vaccumlabs.jpg": 187,
	"./Watermelon.jpeg": 188,
	"./abaka.jpg": 189,
	"./africa.jpeg": 190,
	"./ambidextr.jpeg": 191,
	"./appway.png": 192,
	"./arabnet.jpeg": 193,
	"./aroundb.png": 194,
	"./avaya.png": 195,
	"./azentio.jpg": 196,
	"./backbase.jpeg": 197,
	"./backbase.png": 198,
	"./bankingcio.jpeg": 199,
	"./bankserv.jpg": 200,
	"./bc.jpeg": 201,
	"./beingcrypto.png": 202,
	"./bigdata.jpeg": 203,
	"./blocksocial.jpeg": 204,
	"./caia.jpeg": 205,
	"./cibe.jpeg": 206,
	"./coforge.jpg": 207,
	"./coinpedia.jpeg": 208,
	"./coinquora.png": 209,
	"./coinrepublic.png": 210,
	"./coinsflare.jpeg": 211,
	"./comarch.jpeg": 212,
	"./comforte_logo.png": 213,
	"./comviva.png": 214,
	"./confluent.jpg": 215,
	"./conrad.png": 216,
	"./consdata.jpeg": 217,
	"./creatio.png": 218,
	"./cryptoSaudi.png": 219,
	"./cryptonewz.jpeg": 220,
	"./daon.jpg": 221,
	"./darktrace.png": 222,
	"./difc.jpg": 223,
	"./difc.png": 224,
	"./edb.png": 225,
	"./expo.jpeg": 226,
	"./expo2020.png": 227,
	"./faloos.jpg": 228,
	"./findbiometrics.jpeg": 229,
	"./fintech.jpeg": 230,
	"./fintechfinance.jpeg": 231,
	"./fintechfutures.jpeg": 232,
	"./fintechgalaxy.jpeg": 233,
	"./fintechgalaxy.jpg": 234,
	"./fintechpower.jpeg": 235,
	"./fintechtimes.jpeg": 236,
	"./fireeye.png": 237,
	"./freshworks.png": 238,
	"./fss.png": 239,
	"./hcl.jpg": 240,
	"./hyperpay.jpeg": 241,
	"./ibm.jpeg": 242,
	"./ids.png": 243,
	"./ie.jpg": 244,
	"./igologic.jpg": 245,
	"./iib.jpeg": 246,
	"./infobip.jpeg": 247,
	"./infosys.jpg": 248,
	"./infrasoft.png": 249,
	"./investera.jpeg": 250,
	"./kissflow.jpg": 251,
	"./kitamo.jpeg": 252,
	"./maxut.png": 253,
	"./menafintech.jpeg": 254,
	"./microsoft.png": 255,
	"./mobileidworld.jpeg": 256,
	"./neosoft.png": 257,
	"./network.jpg": 258,
	"./newgen.png": 259,
	"./onespan.jpeg": 260,
	"./onespan.jpg": 261,
	"./openfactor.png": 262,
	"./oracle.jpeg": 263,
	"./oxford.png": 264,
	"./paypers.jpg": 265,
	"./piotech.png": 266,
	"./privatebanking.jpeg": 267,
	"./pwc.jpeg": 268,
	"./pwc.jpg": 269,
	"./rakbank.png": 270,
	"./recorded.png": 271,
	"./regtech.png": 272,
	"./scventure.jpg": 273,
	"./sinofy.png": 274,
	"./skiply.png": 275,
	"./smart.png": 276,
	"./smartmessage.png": 277,
	"./smartstream.jpeg": 278,
	"./smartstream.png": 279,
	"./tata.jpeg": 280,
	"./tcs.jpg": 281,
	"./telco.jpeg": 282,
	"./temenos.jpg": 283,
	"./threatLocker.jpg": 284,
	"./tripwire.jpeg": 285,
	"./truebanking.jpeg": 286,
	"./turbonomic.png": 287,
	"./ufg.png": 288,
	"./unlock.png": 289,
	"./yethi.png": 290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;